// Slovak

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `otvorené do ${date}` : ''),
    },
    interview: {
      title: 'Odpovedať na video pohovor',
      submit: 'Odoslať odpovede a ukončiť pohovor',
      continueLater: 'Pokračovať neskôr',
      startInterview: 'Spustiť pohovor',
      duplicateError: 'Tohto pohovoru ste sa už zúčastnili. Dostali ste e-mail z adresy invitations@recright.com, ktorý obsahuje odkaz umožňujúci pokračovať v pohovore.',
      confirmSubmitHeader: 'Neodpovedali ste na všetky otázky pohovoru',
      confirmSubmitContent: 'Naozaj chcete pohovor dokončiť?',
      confirmSubmitContentWarning: 'Potom už svoje odpovede nebudete môcť doplniť.',
      submitInterviewHeader: 'Odoslať odpovede pohovoru',
      submitInterviewContent: 'Naozaj chcete pohovor odoslať?',
      confirmSubmitButton: 'Odoslať odpoveď a dokončiť pohovor',
      preview: 'Tu si môžete pozrieť ukážku video otázok.',
      withdrawLink: 'U˛ nemįte zįujem o tśto pracovnś pozķciu? Tu mō˛ete odstśpi¯ z vżberového konania.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Názov',
      city: 'Rodné mesto',
      email: 'E-mail',
      phone: 'Telefónne číslo',
      link: 'Odkaz',
      legendBasicInfo: 'Základné informácie',
      placeholderName: 'Zadajte svoje meno',
      placeholderEmail: 'Zadajte svoj e-mail',
      placeholderPhone: 'Zadajte svoj telefón',
      placeholderCity: 'Zadajte svoje súčasné domovské mesto',
      placeholderLink: 'Pridajte odkaz, napríklad odkaz na svoj profil LinkedIn.',
      legendAttachments: 'Prílohy',
      legendAdditionalFields: 'Doplňujúce informácie',
      required: 'Položky označené hviezdičkou * sú povinné.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Zvuk',
        video: 'Video',
        yes: 'Áno',
        no: 'Nie',
        supported: 'Podporované',
        quality: 'Kvalita',
        header: 'Skúška sieťového pripojenia a zariadenia',
        description: 'Teraz spustíme skúšku, aby sme sa uistili, že vaše sieťové pripojenie a zariadenia potrebné na pohovor (kamera a telefón) fungujú správne. Po zobrazení výzvy umožnite, aby sa vaša kamera a mikrofón použili v rámci skúšky a uistite sa, že kamera nie je zakrytá. Skúška bude trvať približne 30 sekúnd. Odporúčame, aby ste počas skúšky zariadení hovorili.',
        inProgress: 'Prebieha skúška...',
        networkTestResults: 'Výsledky skúšky siete',
        qualityTestResults: 'Výsledky skúšky kvality',
        testPassedQuality: 'Skúška kvality bola úspešná',
        testFailedQuality: 'Test kvality bol neúspešný',
        testPassedNetwork: 'Sieťový test bol úspešný',
        testFailedNetwork: 'Skúška siete bola neúspešná',
        startTest: 'Začať skúšku',
        startInterview: 'Začať pohovor',
        testAgain: 'Vyskúšať znova',
        confirmWarning: 'Po spustení videopohovoru sa automaticky zobrazí prvá otázka pohovoru. Po jej prečítaní dostanete čas na prípravu odpovede.',
        confirmTitle: 'Chystáte sa začať pohovor',
        confirmText: 'Po zobrazení každej otázky dostanete chvíľu na prípravu odpovede. Na zodpovedanie otázky je vopred určený časový limit. Svoju odpoveď môžete odoslať aj pred uplynutím časového limitu na zodpovedanie otázky.',
        confirmText2: 'Po odoslaní odpovede vás presunieme na ďalšiu otázku, kým nezodpoviete všetky otázky.',
        confirmText3:
          'Upozorňujeme, že po nahratí odpovede na otázku budete mať 30 sekúnd na opätovné nahranie odpovede, ak je to pre danú otázku povolené. Ak počas týchto 30 sekúnd nezačnete opakované nahrávanie, vaša aktuálna odpoveď sa automaticky odošle a spustí sa ďalšia otázka.',
        goodLuck: 'Zhlboka sa nadýchnite a bude to v poriadku. Veľa šťastia!',
        qualityRating: {
          excellent: 'Vynikajúca',
          good: 'Dobrá',
          fair: 'Priemerná',
          poor: 'Slabá',
          bad: 'Zlá',
        },
      },
      questionAnswerView: {
        title: title => `Odpoveď na pohovor ${title}`,
        question: 'Otázka',
        submitAndNext: 'Odoslať a ďalej',
        submitSuccess: 'Video úspešne odoslané!',
        skipText: 'Spustiť nahrávanie',
        stop: 'Zastaviť',
        submitAndFinish: 'Odošlite a dokončite pohovor',
        retake: 'Opravný',
        take: 'Trvá',
        takesLeft: 'Ostáva',
        skipTextQuestion: 'Pripravení? Preskočiť',
        retakeConfirmTitle: 'Naozaj chcete znova nahrať odpoveď na túto otázku?',
        retakeConfirmSubmit: 'Áno, začať opätovné nahrávanie.',
        submitInfoForward: 'Automatické odoslanie aktuálnej odpovede a pokračovanie za',
        submitInfoForward2: 's',
        nonAnswerableText: 'Na túto správu nemusíte odpovedať. Po tejto správe vás presmerujeme priamo na ďalšiu otázku.',
        nonAnswerableVideo: 'Na toto video nemusíte odpovedať. Po tomto videu vás presmerujeme priamo na ďalšiu otázku.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Na zodpovedanie otázky máte ${answerMinutes} min a ${answerSeconds} s.`,
      },
      publisher: {
        toNextQuestion: timer => `Prechod na ďalšiu otázku o ${timer}`,
        recordingStarts: timer => `Nahrávanie začne o ${timer}`,
      },
      errors: {
        tooManyConnections: 'Toto spojenie bolo ukončené, pretože už je na inej karte alebo v inom okne otvorené iné spojenie.',
        unsupportedBrowser: 'Ľutujeme, túto operáciu nepodporuje váš prehliadač. Použite iný prehliadač.',
        networkError: 'Žiadne pripojenie na internet.',
        reconnecting: 'Spojenie bolo prerušené. Prebieha pokus o opätovné pripojenie.',
        generalError: 'Došlo k chybe. Obnovte stránku a skúste to znova.',
        allowMediaDevicesError: 'Pri tejto operácii sa nepodarilo zistiť mediálne zariadenia (kamera alebo mikrofón). Uistite sa, že ste povolili používanie kamery a mikrofónu v prehliadači.',
        noAvailableDevicesError: 'Nepodarilo sa nájsť kameru alebo mikrofón.',
        initPublisherError: 'Operácia zlyhala kvôli chybe. Skontrolujte, či ste prehliadaču povolili používať fotoaparát a mikrofón a či ich nepoužíva iná aplikácia, a skúste znova.',
      },
      browserInfo: {
        browserSupportTitle: 'Podpora prehliadačov',
        supportedBrowsers: 'Táto skúška a pohovor podporujú najnovšie verzie prehliadačov Chrome, Firefox, Safari a Edge.',
        mobileSupported: 'Podporované prehliadače na mobilných zariadeniach',
        android: 'Android: Google Chrome (najnovšia verzia), Firefox (najnovšia verzia)',
        iOS: 'iOS: Safari (najnovšia verzia)',
        latestVersion: 'Uistite sa, že používate najnovšiu verziu prehliadača. Cieľom je zabezpečiť, aby všetko bez problémov fungovalo.',
        freezeInstruction: 'Ak sa nahrávanie videa nespustí alebo obrazovka nahrávania zostane čierna, obnovte stránku.',
        unsupportedOnIos: 'Zdá sa, že používate prehliadač nepodporovaný v systéme iOS. Použite prehliadač Safari.',
        ieUnsupported: 'Zdá sa, že používate prehliadač Internet Explorer. Táto skúška a pohovor nepodporujú prehliadač Internet Explorer. Použite iný prehliadač.',
        qualityTestNotSupported: 'Testovanie zariadení nie je podporované vo vami používanom prehliadači. Môžete pokračovať v pohovore bez vykonania skúšky kvality zvuku a videa alebo môžete použiť iný prehliadač.',
      },
      reconnectSuccess: 'Opätovné pripojenie bolo úspešné!',
      continue: 'Pokračovať',
    },

    withdraw: {
      title: 'U˛ nemįte zįujem o tśto pracovnś pozķciu?',
      description: 'Odstśpte z vżberového konania.',
      buttonText: 'Odstśpi¯ z vżberového konania',
      thankYouTitle: 'Ļakujeme!',
      thankYouText: 'Teraz ste informovali nįborovżch pracovnķkov o tom, ˛e u˛ nemįte zįujem o tśto pracovnś pozķciu.',
      confirm: 'Naozaj chcete odstśpi¯ z vżberového konania? Po odstśpenķ u˛ nebudete mōc¯ reagova¯ na tento ani ˛iadny inż pracovnż pohovor tżkajści sa tejto pracovnej pozķcie.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Odoslať',
      continue: 'Pokračovať',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Ďakujeme za vašu video odpoveď! Čoskoro vás budeme kontaktovať!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Ďakujeme vám, že ste sa zúčastnili pohovoru!',
      reopenDescription: 'V prípade, že ste pohovor uzavreli náhodou, nemusíte sa obávať! Pohovor môžete znova otvoriť kliknutím na tlačidlo nižšie!',
      reopenButtonText: 'Znovu otvoriť pohovor',
      description1: 'Skvelé. Zodpovedali ste všetky otázky a boli odoslané príjemcovi.',
      descriptionsupport: mailto => `Ak ste tento pohovor zatvorili omylom, kontaktujte naše služby zákazníkom na ${mailto} a my váš pohovor znova otvoríme.`,
      descriptionfeedback: 'Vaše skúsenosti sú pre nás dôležité! Ako hodnotíte svoj dojem z video pohovoru? Ako by ste naše služby zlepšili? Zanechajte tu svoju spätnú väzbu.',
      feedbackbutton: 'Zanechajte nám spätnú väzbu!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Osobná správa',
    },

    closed: {
      title: 'Pohovor je dokončený alebo sa skončil',
      description: 'Video pohovor, na ktorý ste dostali pozvanie, sa už skončil, alebo ste dokončili svoje odoslanie.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Váš video pohovor je teraz uložený!',
      description: 'Keď budete chcieť v tomto video pohovore pokračovať, použite odkaz, ktorý ste dostali na svoj e-mail. Už zaznamenané video odpovede budú aj po návrate na svojom mieste. Prajeme veľa šťastia pri hľadaní zamestnania!',
      remember: 'Nezabudnite odpovede po dokončení odpovedania na pohovor odoslať náborovému pracovníkovi.',
      deleteHistory: 'Ak absolvujete video pohovor na verejnom počítači, nezabudnite si vymazať históriu prehliadania. Váš pohovor tak bude v bezpečí.',
    },
    unpublished: {
      title: 'Pohovor sa ešte nezačal',
      publishTime: publishTime => `Pohovor sa začne o ${publishTime}`,
    },
  },
}
